import React from "react";
import { Row, Col, Form } from "antd";

const ServiceWithParameter = ({
  label,
  special,
  children,
  className,
  wrapperSpan,
  wrapperOffset,
}) => (
  <Row>
    <Col>
      <Form.Item
        label={label}
        labelAlign="left"
        labelCol={{ offset: 3, span: 5 }}
        wrapperCol={{ span: wrapperSpan || 7, offset: wrapperOffset || 3 }}
        className={
          className || special
            ? "services-form-parameter-special"
            : "services-form-parameter"
        }
      >
        {children}
      </Form.Item>
    </Col>
  </Row>
);

export default ServiceWithParameter;
